import { isAxiosError } from "axios"
import { z } from "zod"

/** Only Julo admins may use this app. */
export class NotAdminError extends Error {
  constructor() {
    super("Kontot saknar administratörsbehörighet")
  }
}

const apiErrorBodySchema = z.object({ message: z.string() })

/** The API's own message, e.g. a ConflictException's, or the fallback. */
export const getApiErrorMessage = (error: Error, fallback: string): string => {
  if (!isAxiosError(error)) return fallback
  const body = apiErrorBodySchema.safeParse(error.response?.data)
  return body.success ? body.data.message : fallback
}
